"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesApi = exports.FilesApiFactory = exports.FilesApiFp = exports.FilesApiAxiosParamCreator = exports.AttemptsApi = exports.AttemptsApiFactory = exports.AttemptsApiFp = exports.AttemptsApiAxiosParamCreator = exports.CreateAttemptDtoV1LanguageEnum = void 0;
const axios_1 = require("axios");
const common_1 = require("./common");
const base_1 = require("./base");
exports.CreateAttemptDtoV1LanguageEnum = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
const AttemptsApiAxiosParamCreator = function (configuration) {
    return {
        createAttempt: async (attempt, audio, options = {}) => {
            const localVarPath = `/v1/attempts`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (attempt !== undefined) {
                localVarFormParams.append('attempt', attempt);
            }
            if (audio !== undefined) {
                localVarFormParams.append('audio', audio, 'audio');
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers, ...localVarFormParams.getHeaders() };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteAttempts: async (attemptsFilterDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('deleteAttempts', 'attemptsFilterDtoV1', attemptsFilterDtoV1);
            const localVarPath = `/v1/attempts/delete`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attemptsFilterDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        downloadAttempts: async (inlineObject2, options = {}) => {
            (0, common_1.assertParamExists)('downloadAttempts', 'inlineObject2', inlineObject2);
            const localVarPath = `/v1/attempts/download`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject2, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAttempt: async (id, options = {}) => {
            (0, common_1.assertParamExists)('getAttempt', 'id', id);
            const localVarPath = `/v1/attempts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAttempts: async (publisherId, groupId, userId, expired, options = {}) => {
            const localVarPath = `/v1/attempts`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }
            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeAttempt: async (id, options = {}) => {
            (0, common_1.assertParamExists)('removeAttempt', 'id', id);
            const localVarPath = `/v1/attempts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAttempt: async (id, updateAttemptDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('updateAttempt', 'id', id);
            (0, common_1.assertParamExists)('updateAttempt', 'updateAttemptDtoV1', updateAttemptDtoV1);
            const localVarPath = `/v1/attempts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAttemptDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AttemptsApiAxiosParamCreator = AttemptsApiAxiosParamCreator;
const AttemptsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AttemptsApiAxiosParamCreator)(configuration);
    return {
        async createAttempt(attempt, audio, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAttempt(attempt, audio, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteAttempts(attemptsFilterDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttempts(attemptsFilterDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async downloadAttempts(inlineObject2, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttempts(inlineObject2, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getAttempt(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttempt(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getAttempts(publisherId, groupId, userId, expired, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttempts(publisherId, groupId, userId, expired, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async removeAttempt(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAttempt(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateAttempt(id, updateAttemptDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAttempt(id, updateAttemptDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AttemptsApiFp = AttemptsApiFp;
const AttemptsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AttemptsApiFp)(configuration);
    return {
        createAttempt(attempt, audio, options) {
            return localVarFp.createAttempt(attempt, audio, options).then((request) => request(axios, basePath));
        },
        deleteAttempts(attemptsFilterDtoV1, options) {
            return localVarFp.deleteAttempts(attemptsFilterDtoV1, options).then((request) => request(axios, basePath));
        },
        downloadAttempts(inlineObject2, options) {
            return localVarFp.downloadAttempts(inlineObject2, options).then((request) => request(axios, basePath));
        },
        getAttempt(id, options) {
            return localVarFp.getAttempt(id, options).then((request) => request(axios, basePath));
        },
        getAttempts(publisherId, groupId, userId, expired, options) {
            return localVarFp.getAttempts(publisherId, groupId, userId, expired, options).then((request) => request(axios, basePath));
        },
        removeAttempt(id, options) {
            return localVarFp.removeAttempt(id, options).then((request) => request(axios, basePath));
        },
        updateAttempt(id, updateAttemptDtoV1, options) {
            return localVarFp.updateAttempt(id, updateAttemptDtoV1, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AttemptsApiFactory = AttemptsApiFactory;
class AttemptsApi extends base_1.BaseAPI {
    createAttempt(attempt, audio, options) {
        return (0, exports.AttemptsApiFp)(this.configuration).createAttempt(attempt, audio, options).then((request) => request(this.axios, this.basePath));
    }
    deleteAttempts(attemptsFilterDtoV1, options) {
        return (0, exports.AttemptsApiFp)(this.configuration).deleteAttempts(attemptsFilterDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    downloadAttempts(inlineObject2, options) {
        return (0, exports.AttemptsApiFp)(this.configuration).downloadAttempts(inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }
    getAttempt(id, options) {
        return (0, exports.AttemptsApiFp)(this.configuration).getAttempt(id, options).then((request) => request(this.axios, this.basePath));
    }
    getAttempts(publisherId, groupId, userId, expired, options) {
        return (0, exports.AttemptsApiFp)(this.configuration).getAttempts(publisherId, groupId, userId, expired, options).then((request) => request(this.axios, this.basePath));
    }
    removeAttempt(id, options) {
        return (0, exports.AttemptsApiFp)(this.configuration).removeAttempt(id, options).then((request) => request(this.axios, this.basePath));
    }
    updateAttempt(id, updateAttemptDtoV1, options) {
        return (0, exports.AttemptsApiFp)(this.configuration).updateAttempt(id, updateAttemptDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AttemptsApi = AttemptsApi;
const FilesApiAxiosParamCreator = function (configuration) {
    return {
        deleteFile: async (id, options = {}) => {
            (0, common_1.assertParamExists)('deleteFile', 'id', id);
            const localVarPath = `/v1/files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        downloadFile: async (id, options = {}) => {
            (0, common_1.assertParamExists)('downloadFile', 'id', id);
            const localVarPath = `/v1/files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadFile: async (file, options = {}) => {
            const localVarPath = `/v1/files`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FilesApiAxiosParamCreator = FilesApiAxiosParamCreator;
const FilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FilesApiAxiosParamCreator)(configuration);
    return {
        async deleteFile(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async downloadFile(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFile(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async uploadFile(file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(file, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.FilesApiFp = FilesApiFp;
const FilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FilesApiFp)(configuration);
    return {
        deleteFile(id, options) {
            return localVarFp.deleteFile(id, options).then((request) => request(axios, basePath));
        },
        downloadFile(id, options) {
            return localVarFp.downloadFile(id, options).then((request) => request(axios, basePath));
        },
        uploadFile(file, options) {
            return localVarFp.uploadFile(file, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FilesApiFactory = FilesApiFactory;
class FilesApi extends base_1.BaseAPI {
    deleteFile(id, options) {
        return (0, exports.FilesApiFp)(this.configuration).deleteFile(id, options).then((request) => request(this.axios, this.basePath));
    }
    downloadFile(id, options) {
        return (0, exports.FilesApiFp)(this.configuration).downloadFile(id, options).then((request) => request(this.axios, this.basePath));
    }
    uploadFile(file, options) {
        return (0, exports.FilesApiFp)(this.configuration).uploadFile(file, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FilesApi = FilesApi;
//# sourceMappingURL=api.js.map